type EnglishSuffix = 'one' | 'other';

type SingularTranslationKeysObject<Keys extends Record<string, string>> = {
  [Key in keyof Keys as Key extends `${infer KeyWithoutSuffix}_${EnglishSuffix}`
    ? KeyWithoutSuffix
    : Key]: Key extends `${infer KeyWithoutSuffix}_${EnglishSuffix}`
    ? KeyWithoutSuffix
    : Key;
};

function removeSuffix(key: string) {
  return key.replace(/_(one|other)$/, '');
}

export function createTranslationKeysObject<
  TranslationObject extends Record<string, string>,
>(translationsObject: TranslationObject) {
  const translationKeys =
    {} as SingularTranslationKeysObject<TranslationObject>;

  for (const key of Object.keys(translationsObject)) {
    if (key.endsWith('_one') || key.endsWith('_other')) {
      const keyWithoutSuffix = removeSuffix(key);
      Object.assign(translationKeys, {
        [keyWithoutSuffix]: keyWithoutSuffix,
      });
      continue;
    }

    Object.assign(translationKeys, { [key]: key });
  }

  return translationKeys;
}
